import { useTranslation } from 'react-i18next'

import { UserAvatar } from './user-avatar'
import { getDisplayName, getUserInitial, type AppShellUser } from './user-display'

function ChevronsUpDownIcon() {
  return (
    <svg aria-hidden className="size-[16px]" fill="none" viewBox="0 0 12 12">
      <path
        d="m3.5 4.5 2.5-2 2.5 2M8.5 7.5 6 9.5l-2.5-2"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.15"
      />
    </svg>
  )
}

export function SidebarUser({
  collapsed,
  menuOpen,
  onToggleMenu,
  user,
}: {
  collapsed: boolean
  menuOpen: boolean
  onToggleMenu: () => void
  user: AppShellUser
}) {
  const { t } = useTranslation('shell')
  const displayName = getDisplayName(user, t('userMenu.fallbackName'))
  const initial = getUserInitial(user, t('userMenu.fallbackName'))
  const avatarSrc = user.avatar?.trim()

  if (collapsed) {
    return (
      <div className="border-t border-[var(--color-sidebar-border-subtle)] p-2">
        <button
          aria-expanded={menuOpen}
          aria-label={t('userMenu.toggle')}
          className="mx-auto flex size-10 cursor-pointer items-center justify-center overflow-visible rounded-lg transition-colors hover:bg-[var(--color-sidebar-hover)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--color-focus)]"
          onClick={onToggleMenu}
          type="button"
        >
          <UserAvatar initial={initial} src={avatarSrc} />
        </button>
      </div>
    )
  }

  return (
    <div className="border-t border-[var(--color-sidebar-border-subtle)] p-2">
      <button
        aria-expanded={menuOpen}
        aria-label={t('userMenu.toggle')}
        className="relative h-11 w-full min-w-0 cursor-pointer overflow-hidden rounded-lg transition-colors hover:bg-[var(--color-sidebar-hover)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--color-focus)]"
        onClick={onToggleMenu}
        type="button"
      >
        <span className="absolute left-2.5 top-1/2 -translate-y-1/2 translate-x-0">
          <UserAvatar initial={initial} src={avatarSrc} />
        </span>
        <span
          className="absolute left-[50px] right-8 top-1/2 min-w-0 -translate-y-1/2 truncate text-left text-sm font-medium leading-none text-[var(--color-sidebar-text)]"
          title={displayName}
        >
          {displayName}
        </span>
        <span className="absolute right-3 top-1/2 -translate-y-1/2 text-[var(--color-sidebar-text)]">
          <ChevronsUpDownIcon />
        </span>
      </button>
    </div>
  )
}
